export default {
  getDialogControls(state: any): any {
    return state.dialogControls;
  },
};
